meedy.controller('meedy.popupVideoConsultationConnectionController', ['$rootScope', '$scope', '$sce', '$state', '$timeout', '$mdDialog', '$window', 'objectHelper', 'applicationModel', 'mainModel', 'meedy.userModel', 'meedy.videoConsultationModel', 'meedy.termModel', 'OTSession',
  function ($rootScope, $scope, $sce, $state, $timeout, $mdDialog, $window, objectHelper, applicationModel, mainModel, userModel, videoConsultationModel, termModel, OTSession) {

    function setData() {
      $scope.waitingTime = 1000 * 3 * 60; //3 minutes

      $scope.viewState = Enum.MEEDY.VIDEO_CONSULTATION_STATE.CONNECTING;

      $scope.Enum = Enum;
      $scope.asking = false;
      $scope.sendBegin = false;

      $scope.patientWidth = 640;
      $scope.patientHeight = 480;
      $scope.myWidth = 80;
      $scope.myHeight = 60;

      $scope.session = null;
      $scope.currentSubscriber = null;
      $scope.publisher = null;
      $scope.apiKey = "45396742";
      $scope.sessionId = "2_MX40NTM5Njc0Mn5-MTQ0NjU1ODUxMzI0M35nZy9JeGM5QUFPU2VZL3dZRk93UzY1NFd-UH4";
      $scope.token = "T1==cGFydG5lcl9pZD00NTM5Njc0MiZzaWc9ZDU5YzJkZGM4YmFkMmU4ZWI4MDU1MjA4ZDdmNDU5NTk5YmNiZjg2MTpyb2xlPXB1Ymxpc2hlciZzZXNzaW9uX2lkPTJfTVg0ME5UTTVOamMwTW41LU1UUTBOalUxT0RVeE16STBNMzVuWnk5SmVHTTVRVUZQVTJWWkwzZFpSazkzVXpZMU5GZC1VSDQmY3JlYXRlX3RpbWU9MTQ0NjU1ODUzNyZub25jZT0wLjgzMjg2NTAyMzAwNzk1ODQmZXhwaXJlX3RpbWU9MTQ0OTE1MDUwOSZjb25uZWN0aW9uX2RhdGE9";

      $scope.patientScreen = angular.element("#patientScreen");
      $scope.myScreen = angular.element("#myScreen");

      $scope.minimizeView = false;
      $scope.permissionDenied = false;

      $scope.countDownTimeout = null;
      $scope.stream = null;

      $scope.streamingDetails = videoConsultationModel.details;
      $scope.destroyed = false;
      videoConsultationModel.details = undefined;

      $scope.files = [];

      var isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
      // Opera 8.0+ (UA detection to detect Blink/v8-powered Opera)
      var isFirefox = typeof InstallTrigger !== 'undefined';   // Firefox 1.0+
      var isSafari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;
      // At least Safari 3+: "[object HTMLElementConstructor]"
      var isChrome = !!window.chrome && !isOpera;              // Chrome 1+
      var isIE = /*@cc_on!@*/false || !!document.documentMode; // At least IE6



      $scope.mediaConstraints = {
        audio: true,
        video: true
      };

      OT.on('exception', function (event, data) {
        console.log('OT exception: ' + event.message);
        if (event.code === 1554 && $scope.viewState === Enum.MEEDY.VIDEO_CONSULTATION_STATE.CONNECTED) {
          console.log('Firewall exception');
          $scope.destroySessionData();
          $scope.viewState = Enum.MEEDY.VIDEO_CONSULTATION_STATE.PATIENT_NETWORK_ISSUE;
        }
      });

      var layoutContainer = document.getElementById("chatContainer");

      // Initialize the layout container and get a reference to the layout method
      $scope.layout = initLayoutContainer(layoutContainer).layout;

    }

    function setListeners() {
      $scope.$on('$destroy', function (event) {
        $scope.finishChat();
      });

      $scope.$on(Event.MEEDY.VIDEO_CONSULTATION.BEGIN.SUCCESS, function (event, time) {
        console.log('$scope.$on(Event.MEEDY.VIDEO_CONSULTATION.BEGIN.SUCCESS, function (event, time)');
        var ackWrapper = new AckStatusWrapperVO();
        ackWrapper.portalIdOrder = $scope.streamingDetails.idOrder;
        ackWrapper.status = Enum.MEEDY.VIDEO_CONSULTATION_ACK_STATUS.ONLINE;
        videoConsultationModel.sendACKStatus(ackWrapper);
      });


      $scope.$on(Event.MEEDY.VIDEO_CONSULTATION.ATTACHED_FILE_RETRIVED.SUCCESS, function (event, fileDetails) {
        console.log('Event.MEEDY.VIDEO_CONSULTATION.ATTACHED_FILE_RETRIVED.SUCCESS ' + fileDetails);
        if ($scope.streamingDetails.idOrder == fileDetails.idOrder) {

          var fd = _.find($scope.files, function(f){ f.id==fileDetails.id});
          if(!fd) {
            var file = new TermAttachmentVO();
            file.id = fileDetails.id;
            file.fileName = fileDetails.name;
            file.linkToFile = fileDetails.linkToFile;

            $scope.files.push(file);
          }
        }
      });

      $scope.$on(Event.MEEDY.TERM.GET_ATTACHMENTS.SUCCESS, function (event, files) {
        console.log('Event.MEEDY.TERM.GET_ATTACHMENTS.SUCCESS ' + files);
        $scope.files = files;
      });

      $scope.$watch
      (
        function () {
          return $("#video-popup").height();
        },
        function (newValue, oldValue) {
          if (newValue != oldValue && $scope.viewState === Enum.MEEDY.VIDEO_CONSULTATION_STATE.CONNECTED) {
            $timeout(function () {
              $($("#myScreen").children()[0]).css('height', (newValue - 87) / 4);
              $($("#patientScreen").children()[0]).css('height', newValue - 87);
              $("#patientAttachmentsList").css('height', newValue - 87);
              console.log("layout height");
            }, 20);
          }
        }
      );

      $scope.$watch
      (
        function () {
          return $("#video-popup").width();
        },
        function (newValue, oldValue) {
          if (newValue != oldValue && $scope.viewState === Enum.MEEDY.VIDEO_CONSULTATION_STATE.CONNECTED) {
            $timeout(function () {
              // $($("#myScreen").children()[0]).css('width', (newValue - 32) / 4);
              // $($("#patientScreen").children()[0]).css('width', newValue - 32);
              $($("#myScreen").children()[0]).css('width', (newValue - 224) / 4);
              $($("#patientScreen").children()[0]).css('width', newValue - 224);
              console.log("layout width");
            }, 20);
          }
        }
      );
    }

    function setActions() {

      $scope.getAttachments = function () {
        termModel.getAttachments($scope.streamingDetails.idTerm);
      };

      $scope.downloadAttachment = function (file) {
        termModel.downloadAttachment($scope.streamingDetails.idTerm, file.id, file.fileName);
      };

      $scope.countDown = function () {
        $scope.counter = new Date($scope.streamingDetails.endDate).getTime() - new Date().getTime();

        if ($scope.counter > 0 && $scope.viewState === Enum.MEEDY.VIDEO_CONSULTATION_STATE.CONNECTED) {
          $timeout.cancel($scope.countDownTimeout);
          $scope.countDownTimeout = $timeout($scope.countDown, 1000);
        }
      };

      $scope.exit = function () {
        $('#video-popup').css('display', 'none');
        $rootScope.lastIdOrder = undefined;
        $scope.finishChat();
      };

      $scope.minimize = function () {
        $scope.minimizeView = true;
        $scope.leftPopup = $("#video-popup").css('left');
        $scope.topPopup = $("#video-popup").css('top');
        $scope.heightPopup = $("#video-popup").css('height');
        $("#video-popup").css('bottom', '0px');
        $("#video-popup").css('top', 'initial');
        $("#video-popup").css('left', '60px');
        $("#video-popup").css('height', '55px');
      };

      $scope.maximize = function () {
        $scope.minimizeView = false;
        $("#video-popup").css('bottom', 'initial');
        $("#video-popup").css('top', $scope.topPopup);
        $("#video-popup").css('left', $scope.leftPopup);
        $("#video-popup").css('height', $scope.heightPopup);
      };

      $scope.exitOrFinish = function () {
        if ($scope.viewState === Enum.MEEDY.VIDEO_CONSULTATION_STATE.CONNECTED) {
          $scope.askAndFinishChat()
        } else {
          $scope.exit();
        }
      };

      $scope.askAndFinishChat = function () {
        $scope.asking = true;
      };

      $scope.cancel = function () {
        $scope.asking = false;
      };

      $scope.unpackDetails = function () {
        $scope.apiKey = $scope.streamingDetails.apiKey;
        $scope.sessionId = $scope.streamingDetails.sessionID;
        $scope.token = $scope.streamingDetails.physicianToken;

        $scope.connect();
      };

      $scope.onMediaSuccess = function (stream) {
        $scope.stream = stream;
        $scope.getAttachments();
      };

      $scope.destroySessionData = function () {
        if ($scope.session) {
          $scope.session.off();
          $scope.session.disconnect();
        }
        $scope.session = null;
        $scope.currentSubscriber = null;
        $scope.publisher = null;
        $('#patientScreen').html('');
        $('#myScreen').html('');

        $rootScope.lastIdOrder = undefined;
        $scope.files = [];
      };

      $scope.onMediaError = function (err) {
        console.log(err);
      };

      $scope.connect = function () {
        console.log('PopupVideoConsultationConnection connect()');
        $scope.destroyed = false;

        $scope.session = OT.initSession($scope.apiKey, $scope.sessionId);

        $scope.session.on("streamCreated", function (event) {
          $scope.$apply();
          $scope.patientScreen = angular.element("#patientScreen");

          $scope.currentStream = event.stream;

          $scope.currentSubscriber = $scope.session.subscribe($scope.currentStream, $scope.patientScreen[0], {
            width: $scope.patientWidth,
            height: $scope.patientHeight,
            audioVolume: 100,
            buttonDisplayMode: 'off',
            showControls: false,
            insertMode: 'append'
          });


          $scope.viewState = Enum.MEEDY.VIDEO_CONSULTATION_STATE.CONNECTED;
          $scope.countDown();

        });

        $scope.session.on("streamDestroyed", function (event) {
          var subscribers = $scope.session.getSubscribersForStream(event.stream);

          if (event.reason === 'networkDisconnected') {
            event.preventDefault();
            if (subscribers.length > 0 && event.stream.id === $scope.currentSubscriber.streamId) {
              $scope.destroySessionData();

              $scope.errorMessage = 'T.MEEDY.SYSTEM.ERROR.LOST_CONNECTION';
              $scope.viewState = Enum.MEEDY.VIDEO_CONSULTATION_STATE.ERROR;

              $rootScope.lastIdOrder = undefined;

            }
            ;
          } else if (event.reason === 'clientDisconnected' && $scope.viewState === Enum.MEEDY.VIDEO_CONSULTATION_STATE.FINISHED) {
            if (subscribers.length > 0 && event.stream.id === $scope.currentSubscriber.streamId) {
              $scope.finishChat();
              $scope.destroySessionData();
            }
            ;
          } else if (event.reason === 'clientDisconnected' && $scope.viewState === Enum.MEEDY.VIDEO_CONSULTATION_STATE.CONNECTED) {
            $scope.destroySessionData();

            $scope.viewState = Enum.MEEDY.VIDEO_CONSULTATION_STATE.PATIENT_NETWORK_ISSUE;

            $rootScope.lastIdOrder = undefined;
          }
        });

        $scope.session.on("signal:WEB", function (event) {
          $timeout(function () {
            if (!$scope.destroyed) {

              if ($scope.viewState === Enum.MEEDY.VIDEO_CONSULTATION_STATE.CONNECTED) {
                $scope.finishChat();
              } else {
                $scope.cancelled = true;
              }

              $scope.destroyed = true;
            }
          });

        });

        $scope.session.connect($scope.apiKey, $scope.token, function (error) {
          if (error) {
            console.log(error.message);
          } else {

            $scope.maximize();
            $scope.publisher = OT.initPublisher('myScreen', {
              width: $scope.myWidth,
              height: $scope.myHeight,
              insertMode: "append",
              buttonDisplayMode: 'off',
              showControls: false
            }, function (error) {
              if (error) {
                $scope.errorMessage = 'T.MEEDY.SYSTEM.ERROR.ACCESS_DENIED';
                $scope.viewState = Enum.MEEDY.VIDEO_CONSULTATION_STATE.ERROR;
              } else {

                if (navigator.mediaDevices.getUserMedia) {
                  navigator.mediaDevices.getUserMedia($scope.mediaConstraints)
                    .then($scope.onMediaSuccess)
                    .catch($scope.onMediaError);
                } else {
                  alert('getUserMedia() is not supported in your browser');
                }

              }
            });

            $scope.session.publish($scope.publisher, function (error) {
              if (error) {
                console.log(error);
              } else {

                if (!$scope.sendBegin) {
                  $scope.sendBegin = true;

                  var wrapper = new BeginOnlineConsultationWrapperVO();
                  wrapper.idOrder = $scope.streamingDetails.idOrder;
                  wrapper.userType = Enum.MEEDY.VIDEO_CONSULTATION_USER_TYPE.PHYSICIAN;
                  wrapper.startTime = new Date().getTime();
                  wrapper.environmentDetails = navigator.userAgent;

                  videoConsultationModel.beginVideoConsultation(wrapper);
                  $scope.stopAnyDevice();
                }
              }
            });

          }
        });
      };

      $scope.stopAnyDevice = function () {
        if ($scope.stream) {
          $scope.stream.getTracks().forEach(function(track) {
            track.stop();
          });
        }
      };

      $scope.finishChat = function () {
        $scope.asking = false;
        if ($scope.session && $scope.session.currentState === 'connected') {

          $scope.stopAnyDevice();

          $scope.session.signal(
            {
              data: 'KILL_ME_PLEASE',
              type: 'MOBILE'
            },
            function (error) {
              if (error) {
              } else {
                $scope.destroySessionData();

                $scope.viewState = Enum.MEEDY.VIDEO_CONSULTATION_STATE.FINISHED;
                var wrapper = new EndOnlineConsultationWrapperVO();
                wrapper.idOrder = $scope.streamingDetails.idOrder;
                wrapper.userType = Enum.MEEDY.VIDEO_CONSULTATION_USER_TYPE.PHYSICIAN;
                wrapper.endTime = new Date().getTime();

                videoConsultationModel.endVideoConsultation(wrapper);

                var ackWrapper = new AckStatusWrapperVO();
                ackWrapper.portalIdOrder = $scope.streamingDetails.idOrder;
                ackWrapper.status = Enum.MEEDY.VIDEO_CONSULTATION_ACK_STATUS.DISCONNECTED;
                videoConsultationModel.sendACKStatus(ackWrapper);

                $rootScope.lastIdOrder = undefined;
              }
            }
          );

        } else if ($scope.session && $scope.session.currentState === 'disconnected') {
          $scope.session.signal(
            {
              data: 'KILL_ME_PLEASE',
              type: 'MOBILE'
            },
            function (error) {
              if (error) {
              } else {
                $scope.viewState = Enum.MEEDY.VIDEO_CONSULTATION_STATE.FINISHED;
                var wrapper = new AckStatusWrapperVO();
                wrapper.portalIdOrder = $scope.streamingDetails.idOrder;
                wrapper.status = Enum.MEEDY.VIDEO_CONSULTATION_ACK_STATUS.DISCONNECTED;
                videoConsultationModel.sendACKStatus(wrapper);
                $rootScope.lastIdOrder = undefined;
                $('#patientScreen').html('');
                $('#myScreen').html('');
              }
            }
          );
        } else {
          $scope.destroySessionData();

          $scope.viewState = Enum.MEEDY.VIDEO_CONSULTATION_STATE.FINISHED;

          var wrapper = new AckStatusWrapperVO();
          wrapper.portalIdOrder = $scope.streamingDetails.idOrder;
          wrapper.status = Enum.MEEDY.VIDEO_CONSULTATION_ACK_STATUS.DISCONNECTED;
          videoConsultationModel.sendACKStatus(wrapper);

          $rootScope.lastIdOrder = undefined;
          $('#patientScreen').html('');
          $('#myScreen').html('');
        }
      };

      $scope.repeat = function () {
        initialize();
      }
    }

    function initialize() {
      $scope.viewState = Enum.MEEDY.VIDEO_CONSULTATION_STATE.CONNECTING;

      if (!!navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices.getUserMedia($scope.mediaConstraints)
          .then(function(stream) {
            $scope.unpackDetails();
            $scope.stream = stream;
          })
          .catch(function (error) {
            console.log(error);
            $timeout(function () {
              $scope.permissionDenied = true;
            });
          });      
      } else {
        alert('Video Streaming is not supported in your browser');
      }
    }

    $scope.$on(Event.MEEDY.VIDEO_CONSULTATION.START.SUCCESS, function (event, term) {
      $('#patientScreen').html('');
      $('#myScreen').html('');
      $('#video-popup').css('display', 'block');
      $($('#video-popup').children()[0]).css('width', 862);
      $($('#video-popup').children()[0]).css('height', 567);
      
      setData();
      initialize();
    });

    setListeners();
    setActions();
  }
]);
